import React from 'react';
import { Box, Button, ListItemText, Typography } from '@mui/material';
import { useAppDispatch } from '../../../../hooks';
import { closeMobileMenu } from './menuSlice';
import useTranslations from '../../../global/translation/hooks/translation';
import { scrollFn } from '../helper';
import { useThemeContext } from '../../../global/ThemeContext';
import { setLanguage } from '../../../global/translation/translationSlice';
import DarkModeToggle from '../../DarkModeToggle';

const MobileMenuLinks = () => {
  const { currentLanguage, translations } = useTranslations();
  const dispatch = useAppDispatch();
  const { darkMode } = useThemeContext();

  const handleCloseNavMenu = () => {
    dispatch(closeMobileMenu());
  };

  const handleMobileLinkClick = (e: React.MouseEvent<HTMLButtonElement>, section: string) => {
    console.log(`[MobileMenuLinks] Clicked! Scrolling to: ${section}`);
    scrollFn(section);
    console.log(`[MobileMenuLinks] Scheduling menu close.`);
    // Introduce a small delay before closing the menu
    setTimeout(() => {
      console.log(`[MobileMenuLinks] Closing menu now.`);
      handleCloseNavMenu();
    }, 1000); // 50ms delay, adjust if needed
  };

  return (
    <>
      <Button fullWidth onClick={(e) => handleMobileLinkClick(e, 'about')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFF' : '#000' }}>{translations.menuItems.aboutUs[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth onClick={(e) => handleMobileLinkClick(e, 'offer')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFF' : '#000' }}>{translations.menuItems.offer[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth onClick={(e) => handleMobileLinkClick(e, 'horses')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFF' : '#000' }}>{translations.menuItems.horses[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth onClick={(e) => handleMobileLinkClick(e, 'method')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFF' : '#000' }}>{translations.menuItems.method[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth onClick={(e) => handleMobileLinkClick(e, 'pricing')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFF' : '#000' }}>{translations.menuItems.pricing[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth onClick={(e) => handleMobileLinkClick(e, 'team')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFF' : '#000' }}>{translations.menuItems.ourTeam[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth onClick={(e) => handleMobileLinkClick(e, 'contact')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFF' : '#000' }}>{translations.menuItems.contact[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: '0 0 auto', justifyContent: 'center' }}>
        <DarkModeToggle />
        <Button
          onClick={() => {
            currentLanguage === 'en' ? dispatch(setLanguage('pl')) : dispatch(setLanguage('en'));
          }}
          size="large"
          sx={{ minWidth: 0, px: 2, ml: 1, fontWeight: 600, color: darkMode ? '#FFF' : '#000', textTransform: 'none', justifyContent: 'left' }}
        >
          {currentLanguage === 'en' ? 'PL' : 'EN'}
        </Button>
      </Box>
    </>
  );
};

export default MobileMenuLinks;
